import { FlexColumn } from '@/atoms/FlexContainers'
import { PayItForwardOutlineIcon } from '@/atoms/Icons/PayItForwardOutlineIcon'
import { Placeholder } from '@/atoms/Placeholder'
import { LabelMD } from '@/atoms/Text'

export const ExpressPaymentSkeleton = () => (
  <FlexColumn className="w-full gap-3">
    {Array.from({ length: 3 }).map((_, i) => (
      <Placeholder
        key={i}
        placeholderClassName="bg-core-gray-200 justify-center gap-1 animate-pulse flex items-center"
        className="flex h-12 w-full rounded-md border border-core-gray-300"
      >
        <PayItForwardOutlineIcon color={'core-gray-400'} />
        <LabelMD weight="medium" color={'core-gray-400'}>
          Loading
        </LabelMD>
      </Placeholder>
    ))}
  </FlexColumn>
)
